var _ = require('lodash');
var connect = require('./connect');
var facebook = require('./facebook');

module.exports = _.extend({},{
    connect: connect,
    facebook: facebook
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/constants/index.js
// module id = 200
// module chunks = 0